/**
 * Matches the filename parameter in a Content-Disposition header.
 * Captures either a quoted value (group 1 with surrounding quotes)
 * or an unquoted value up to the next semicolon or end of line.
 */
const CONTENT_DISPOSITION_FILENAME_PATTERN =
  /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;

/**
 * Parses the filename from a Content-Disposition header value.
 * Handles both quoted and unquoted forms, e.g.:
 *   attachment; filename="document.pdf"
 *   attachment; filename=document.pdf
 * Returns null when the header is absent or contains no filename parameter.
 */
export function extractFilename(
  contentDisposition: string | undefined
): string | null {
  if (!contentDisposition) return null;

  const match = CONTENT_DISPOSITION_FILENAME_PATTERN.exec(contentDisposition);
  if (!match) return null;

  const filename = match[1].replace(/['"]/g, '').trim();
  return filename.length > 0 ? filename : null;
}
